import { jsxs as s, jsx as t } from "@emotion/react/jsx-runtime";
import { BusinessesContentLayout as e, Title as r } from "./BusinessesContent.styled.js";
import { Footer as n } from "./Footer/Footer.js";
import { useBusinessModalContext as i } from "../../BusinessModalContext.js";
import { Filters as m } from "./Filters/Filters.js";
import { Content as a } from "./Content/Content.js";
const x = () => {
  const {
    translations: o
  } = i();
  return /* @__PURE__ */ s(e, { children: [
    /* @__PURE__ */ t(r, { variant: "heading4", children: o.selectBusiness }),
    /* @__PURE__ */ t(m, {}),
    /* @__PURE__ */ t(a, {}),
    /* @__PURE__ */ t(n, {})
  ] });
};
export {
  x as BusinessesContent
};
